import { render, staticRenderFns } from "./ManageLists.vue?vue&type=template&id=80ba9d02&"
import script from "./ManageLists.vue?vue&type=script&lang=ts&"
export * from "./ManageLists.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports